import React, { useState, useEffect, useContext } from 'react';
import {
  Table,
  Input,
  Button,
  Modal,
  Image,
  Space,
  Select,
  InputNumber,
  message,
  Typography,
  Form,
} from 'antd';
import { SearchOutlined, EyeOutlined, SendOutlined, PlusOutlined } from '@ant-design/icons';
import api from '../../api/axios';
import { AuthContext } from '../../context/AuthContext';

const { Title } = Typography;
const { Option } = Select;

const SearchAndSendSparePart = () => {
  const { user } = useContext(AuthContext);
  const userWareId = user?.warehouseId;

  const [searchText, setSearchText] = useState('');
  const [inventory, setInventory] = useState([]);
  const [filteredInventory, setFilteredInventory] = useState([]);
  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [requestModalVisible, setRequestModalVisible] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [spareParts, setSpareParts] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  // Fetch inventory
  const fetchInventory = async () => {
    try {
      const res = await api.get(`/api/inventories?wareId=${userWareId}`);
      setInventory(res.data);
      setFilteredInventory(res.data);
    } catch (err) {
      console.error(err);
      messageApi.error('Failed to fetch inventory');
    }
  };

  const fetchWarehouses = async () => {
    try {
      const res = await api.get('/api/warehouses');
      setWarehouses(res.data);
    } catch (err) {
      console.error(err);
      messageApi.error('Failed to fetch warehouses');
    }
  };

  const fetchSpareParts = async () => {
    try {
      const res = await api.get('/api/spareparts');
      setSpareParts(res.data);
    } catch (err) {
      console.error(err);
      messageApi.error('Failed to fetch spare parts');
    }
  };

  useEffect(() => {
    fetchInventory();
    fetchWarehouses();
    fetchSpareParts();
  }, []);

  // Filter inventory
useEffect(() => {
  const search = searchText.toLowerCase();

  const filtered = inventory.filter((item) => {
    const partName = item.sparepart?.partName?.toLowerCase() || '';
    const partNumber = item.sparepart?.partNumber?.toLowerCase() || '';
    const importerId = item.sparepart?.importerId?.toLowerCase() || '';
    return (
      partName.includes(search) ||
      partNumber.includes(search) ||
      importerId.includes(search)
    );
  });

  setFilteredInventory(filtered);
}, [searchText, inventory]);


// ✅ Recommended Frontend: Handle JSON and use null for errors
// ======================== VIEW IMAGE (robust & consistent) ========================
const handleViewImage = async (record) => {
  setSelectedImage(null);              // clear previous
  setImageModalVisible(true);          // open modal immediately
  const spareId = record.sparepart?.id;

  try {
    console.log(`Fetching image for ID: ${spareId}`);
    const res = await api.get(`/api/spareparts/${spareId}/image`);

    console.log('API Response:', res.data);

    if (res.data && res.data.spareImage) {
      const imageSrc = `data:image/jpeg;base64,${res.data.spareImage}`;
      setSelectedImage(imageSrc);
    } else {
      console.warn('No spareImage found in the response.');
      messageApi.warning('No image found for this spare part');
    }
  } catch (error) {
    console.error('Image fetch error:', error);
    messageApi.error('Error fetching spare part image');
  }
};
const handleViewImage2 = async (record) => {
  setSelectedImage(null);              // clear previous
  setImageModalVisible(true);          // open modal immediately
  const spareId = record;

  try {
    console.log(`Fetching image for ID: ${spareId}`);
    const res = await api.get(`/api/spareparts/${spareId}/image`);

    console.log('API Response:', res.data);

    if (res.data && res.data.spareImage) {
      const imageSrc = `data:image/jpeg;base64,${res.data.spareImage}`;
      setSelectedImage(imageSrc);
    } else {
      console.warn('No spareImage found in the response.');
      messageApi.warning('No image found for this spare part');
    }
  } catch (error) {
    console.error('Image fetch error:', error);
    messageApi.error('Error fetching spare part image');
  }
};





  const openRequestModal = () => {
    form.resetFields();
    setOrderItems([{ sparepartId: null, warehouseId: null, availableQty: 0, requestedQty: 1 }]);
    setRequestModalVisible(true);
  };

  const updateRow = async (index, key, value) => {
    const newItems = [...orderItems];
    newItems[index][key] = value;

    const item = newItems[index];

    if (item.sparepartId && item.warehouseId) {
      try {
        const res = await api.get(`/api/inventories?wareId=${item.warehouseId}`);
        const part = res.data.find((p) => p.sparepartId === item.sparepartId);
        item.availableQty = part?.quantity || 0;

        if (item.requestedQty > item.availableQty) item.requestedQty = item.availableQty;
      } catch (err) {
        console.error(err);
        messageApi.error('Failed to fetch warehouse inventory');
      }
    }

    setOrderItems(newItems);
  };

  const addOrderRow = () => {
    setOrderItems([...orderItems, { sparepartId: null, warehouseId: null, availableQty: 0, requestedQty: 1 }]);
  };

  const removeRow = (index) => {
    const newItems = [...orderItems];
    newItems.splice(index, 1);
    setOrderItems(newItems);
  };
const printRequisitionForm = (requestData) => {
  const { companyName, shopName, salesOrderNumber, purpose, items, requisitionNumber } = requestData;
  const today = new Date().toLocaleDateString();

  const html = `
    <html>
      <head>
        <title>Stock Requisition Form</title>
        <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
        <style>
          @media print {
            @page {
              size: 210mm 148.5mm; /* Half A4 portrait */
              margin: 10mm;
            }
            body {
              width: 190mm;
              height: 128.5mm;
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 0;
            }
          }

          body { font-family: Arial, sans-serif; padding: 10px; box-sizing: border-box; }
          h2, h3 { text-align: center; margin: 5px; }
          table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 12px; }
          th, td { border: 1px solid #000; padding: 4px; text-align: left; }
          th { background-color: #f0f0f0; }
          .footer { margin-top: 15px; display: flex; justify-content: space-between; font-size: 12px; }
          .footer div { text-align: center; width: 30%; }
          .barcode { text-align: center; margin-top: 10px; }
        </style>
      </head>
      <body>
        <h2>${companyName}</h2>
        <h3>Stock Requisition Form</h3>
        <p><strong>Date:</strong> ${today}</p>
        <p><strong>Stock Requisition Number:</strong> ${requisitionNumber}</p>
        <p><strong>Shop Name:</strong> ${shopName}</p>
        <p><strong>Sales Order Number:</strong> ${salesOrderNumber}</p>
        <p><strong>Purpose:</strong> ${purpose}</p>

        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Part Number</th>
              <th>Description</th>
              <th>Quantity Requested</th>
              <th>Remark</th>
            </tr>
          </thead>
          <tbody>
            ${items.map(i => `
              <tr>
                <td>${i.importerId}</td>
                <td>${i.partNumber}</td>
                <td>${i.partName}</td>
                <td>${i.requestedQty}</td>
                <td>${i.remark || ''}</td>
              </tr>`).join('')}
          </tbody>
        </table>

        <div class="footer">
          <div>
            Requested By<br/><br/>________________<br/>Date
          </div>
          <div>
            Checked By<br/><br/>________________<br/>Date
          </div>
          <div>
            Approved By<br/><br/>________________<br/>Date
          </div>
        </div>

        <div class="barcode">
          <svg id="barcode"></svg>
        </div>

        <script>
          JsBarcode("#barcode", "${salesOrderNumber}", {
            format: "CODE128",
            displayValue: false,
            width: 2,
            height: 50
          });
        </script>
      </body>
    </html>
  `;

  const newWin = window.open('', '_blank');
  newWin.document.write(html);
  newWin.document.close();
  newWin.focus();
  newWin.print();
};





  const handleRequestSubmit = async () => {
    // Validate before sending
    for (const item of orderItems) {
      if (!item.sparepartId || !item.warehouseId) {
        messageApi.error('Please select both spare part and source warehouse');
        return;
      }
      if (item.availableQty <= 0) {
        messageApi.error(`Selected warehouse has no stock for part ID ${item.sparepartId}`);
        return;
      }
    }

    try {
     const  salesOrderNumber= 'SO-' + new Date().getTime();
      const payload = {
        toWarehouseId: userWareId,
        salesOrderNumber,
        items: orderItems.map((i) => ({
          sparepartId: i.sparepartId,
          fromWarehouseId: i.warehouseId,
          requestedQty: i.requestedQty,
        })),
      };
      await api.post('/api/spare-requests', payload);
      messageApi.success('Spare request sent successfully!');
      setRequestModalVisible(false);
      setOrderItems([]);
          const shop = warehouses.find((w) => w.id === userWareId); // find user's shop
    const shopName = shop ? shop.name : 'Main Shop';

      const requisitionData = {
  companyName: 'JS Construction Machinery Spare Parts',
  shopName,
  salesOrderNumber, // generate dynamically
  purpose: 'Spare Parts Request',
  requisitionNumber: 'REQ-' + new Date().getTime(),
  items: orderItems.map(i => {
    const part = spareParts.find(sp => sp.id === i.sparepartId);
    return {
      partNumber: part?.partNumber,
      partName: part?.partName,
      importerId: part?.importerId,
      requestedQty: i.requestedQty,
      remark: '',
    };
  }),
};

printRequisitionForm(requisitionData);
    } catch (err) {
      console.error(err);
      messageApi.error('Failed to send request');
    }
  };

  const columns = [
    { title: 'ID', dataIndex: ['sparepart', 'importerId'], key: 'importerId' },
    { title: 'Part Name', dataIndex: ['sparepart', 'partName'], key: 'partName' },
    { title: 'Part Number', dataIndex: ['sparepart', 'partNumber'], key: 'partNumber' },
    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
   {
  title: 'Actions',
  key: 'actions',
  render: (_, record) => (
    <Button icon={<EyeOutlined />} onClick={() => handleViewImage(record)}>
      View
    </Button>
  ),
},

  ];

  const modalColumns = [
    {
      title: 'Spare Part',
      key: 'sparepartId',
      render: (_, record, index) => (
        <Select
          showSearch
          placeholder="Select Spare Part"
          value={record.sparepartId}
          onChange={(val) => updateRow(index, 'sparepartId', val)}
          filterOption={(input, option) => {
            const data = option?.sparepartData || {};
            const text = `${data.partName || ''} ${data.partNumber || ''} ${data.importerId || ''}`.toLowerCase();
            return text.includes(input.toLowerCase());
          }}
          style={{ width: '100%' }}
          
        >
          {spareParts.map((sp) => (
            <Option key={sp.id} value={sp.id} sparepartData={sp}>
              {sp.partName} ({sp.partNumber}) — {sp.importerId}  <Button
      type="text"
      icon={<EyeOutlined />}
      size="small"
      onClick={() => handleViewImage2(sp.id)}
      style={{ color: '#0891b2' }}
    >
      View
    </Button>
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: 'Source Warehouse',
      key: 'warehouseId',
      render: (_, record, index) => (
        <Select
          placeholder="Select Warehouse"
          value={record.warehouseId}
          onChange={(val) => updateRow(index, 'warehouseId', val)}
          style={{ width: '100%' }}
        >
          {warehouses
            .filter((w) => w.id !== userWareId)
            .map((w) => (
              <Option key={w.id} value={w.id}>
                {w.name}
              </Option>
            ))}
        </Select>
      ),
    },
    { title: 'Available Qty', dataIndex: 'availableQty', key: 'availableQty' },
    {
      title: 'Request Qty',
      key: 'requestedQty',
      render: (_, record, index) => (
        <InputNumber
          min={1}
          max={record.availableQty || 1}
          value={record.requestedQty}
          onChange={(val) => updateRow(index, 'requestedQty', val)}
          disabled={record.availableQty <= 0} // disable if no stock
        />
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, __, index) => (
        <Button danger onClick={() => removeRow(index)}>
          Remove
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: 16 }}>
      {contextHolder}
      <Title level={4}>Search and Send Sparepart Request</Title>

      <Space style={{ marginBottom: 16 }}>
        <Input
          placeholder="Search by Part Name, Part Number, Importer ID"
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          allowClear
          style={{ width: 400 }}
        />
        <Button type="primary" icon={<SendOutlined />} onClick={openRequestModal}>
          Send Spare Request
        </Button>
      </Space>

      <Table columns={columns} dataSource={filteredInventory} rowKey="id" pagination={{ pageSize: 10 }} bordered />

      {/* Image Modal */}
    <Modal
  open={imageModalVisible}
  title="Spare Part Image"
  footer={null}
  onCancel={() => setImageModalVisible(false)}
  centered
>
  {selectedImage ? (
    <img
      src={selectedImage}
      alt="Spare Part"
      style={{
        width: '100%',
        borderRadius: 8,
        objectFit: 'contain',
        maxHeight: '70vh',
      }}
    />
  ) : (
    <p style={{ textAlign: 'center', color: '#888' }}>
      Loading image or no image available...
    </p>
  )}
</Modal>


      {/* Send Spare Request Modal */}
      <Modal
        title="Send Spare Request"
        open={requestModalVisible}
        onCancel={() => setRequestModalVisible(false)}
        onOk={handleRequestSubmit}
        width={900}
      >
        <Button type="dashed" onClick={addOrderRow} block icon={<PlusOutlined />} style={{ marginBottom: 16 }}>
          Add Spare Part
        </Button>

        <Table columns={modalColumns} dataSource={orderItems} rowKey={(record, index) => index} pagination={false} />
      </Modal>
    </div>
  );
};

export default SearchAndSendSparePart;
